/**
 * Norwegian (bokmål) translations, keyed by the English source text.
 * Missing keys fall back to English; i18n.test.ts checks that every key is translated.
 */
export const nb: Record<string, string> = {
  "1 = single, 3 = triple running stitch": "1 = enkel, 3 = trippel løpesting",
  "100 stitches back": "100 sting tilbake",
  "100 stitches forward": "100 sting frem",
  "360 × 350 mm (commercial)": "360 × 350 mm (kommersiell)",
  "Action for the colour": "Handling for fargen",
  "Add the image as a background and draw the shapes yourself": "Legg bildet inn som bakgrunn og tegn formene selv",
  "Add to the design": "Legg til i designet",
  "Analysing colours": "Analyserer farger",
  "Analysing…": "Analyserer…",
  "Applies to the visible motif (background and transparency removed). The aspect ratio is kept.": "Gjelder det synlige motivet (bakgrunn og gjennomsiktighet er fjernet). Sideforholdet bevares.",
  "Appliqué on fabric (twill)": "Applikasjon på stoff (twill)",
  "Area": "Flate",
  "Automatic": "Automatisk",
  "Autosave failed: {msg}. Save the project manually or download the project file.": "Automatisk lagring feilet: {msg}. Lagre prosjektet manuelt eller last ned prosjektfilen.",
  "Background": "Bakgrunn",
  "Background colour": "Bakgrunnsfarge",
  "Black": "Sort",
  "Border": "Kant",
  "Border colour": "Kantfarge",
  "Border width (satin)": "Kantbredde (sateng)",
  "Brother and Baby Lock": "Brother og Baby Lock",
  "Brother and Baby Lock, PE-Design 6 and newer": "Brother og Baby Lock, PE-Design 6 og nyere",
  "By the machine's jump setting": "Etter maskinens hoppinnstilling",
  "Cancel": "Avbryt",
  "Cancel digitizing": "Avbryt digitalisering",
  "Canvas layers": "Lag i lerretet",
  "Centre X": "Midtpunkt X",
  "Centre Y": "Midtpunkt Y",
  "Centre on the design": "Sentrer på designet",
  "Centre run": "Senterløp",
  "Centre the design in the hoop": "Sentrer designet i rammen",
  "Changes to the current project are not saved. Discard them?": "Endringer i gjeldende prosjekt er ikke lagret. Vil du forkaste dem?",
  "Checking…": "Kontrollerer…",
  "Choose another image": "Velg et annet bilde",
  "Choose colour…": "Velg farge…",
  "Choose end point": "Velg sluttpunkt",
  "Choose or drop an image file": "Velg eller slipp en bildefil",
  "Choose start point": "Velg startpunkt",
  "Circle": "Sirkel",
  "Cleaning up colour regions": "Rydder opp i fargeområder",
  "Clear selection": "Fjern valg",
  "Click for actual size (100 %)": "Klikk for faktisk størrelse (100 %)",
  "Click on the canvas to choose the end point · Esc cancels": "Klikk i lerretet for å velge sluttpunkt · Esc avbryter",
  "Click on the canvas to choose the hoop centre · Esc cancels": "Klikk i lerretet for å velge rammens midtpunkt · Esc avbryter",
  "Click on the canvas to choose the start point · Esc cancels": "Klikk i lerretet for å velge startpunkt · Esc avbryter",
  "Close": "Lukk",
  "Close dialog": "Lukk dialogen",
  "Close message": "Lukk melding",
  "Closed line": "Lukket linje",
  "Colour": "Farge",
  "Colour changes": "Fargeskift",
  "Colour for all": "Farge for alle",
  "Colour for {name}": "Farge for {name}",
  "Colour name": "Fargenavn",
  "Colour separation": "Fargeseparering",
  "Colour {n}": "Farge {n}",
  "Colour: {name}. Change colour": "Farge: {name}. Endre farge",
  "Colours": "Farger",
  "Colours and background": "Farger og bakgrunn",
  "Colours are stored as the nearest colour in Brother's 64-colour PEC palette.": "Farger lagres som nærmeste farge i Brothers 64-farge PEC-palett.",
  "Colours are stored as the nearest colour in Janome's palette.": "Farger lagres som nærmeste farge i Janomes palett.",
  "Column": "Kolonne",
  "Command": "Kommando",
  "Command {n} of {total}": "Kommando {n} av {total}",
  "Corner radius": "Hjørneradius",
  "Could not write {format}: {error}": "Kunne ikke skrive {format}: {error}",
  "Creating embroidery objects": "Lager broderiobjekter",
  "Crop area": "Beskjæringsområde",
  "Custom": "Egendefinert",
  "Custom centre point": "Egendefinert midtpunkt",
  "Custom…": "Egendefinert…",
  "DST displacement outside ±121: ({dx}, {dy})": "DST-forskyvning utenfor ±121: ({dx}, {dy})",
  "DST does not store thread colours – only colour changes. Choose the colours on the machine.": "DST lagrer ikke trådfarger – bare fargeskift. Velg farger på maskinen.",
  "Delete": "Slett",
  "Density (spacing, same side)": "Tetthet (avstand på samme side)",
  "Design canvas": "Designlerret",
  "Design size": "Designstørrelse",
  "Design statistics": "Designstatistikk",
  "Diameter": "Diameter",
  "Digitize automatically": "Digitaliser automatisk",
  "Digitized: {n} objects in {c} colours.": "Digitalisert: {n} objekter i {c} farger.",
  "Dimensions": "Mål",
  "Distance to the design": "Avstand til designet",
  "Do not sew (remove)": "Ikke sy (fjern)",
  "Done": "Ferdig",
  "Double-click to rename": "Dobbeltklikk for å gi nytt navn",
  "Download as project file": "Last ned som prosjektfil",
  "Drag to move · Delete removes (min. {n} points) · double-click an edge to add": "Dra for å flytte · Delete fjerner (min. {n} punkter) · dobbeltklikk på kant legger til",
  "Draw a shape": "Tegn en form",
  "Drop an image here, or click to choose": "Slipp et bilde her, eller klikk for å velge",
  "Duplicate": "Dupliser",
  "EXP displacement outside ±127: {v}": "EXP-forskyvning utenfor ±127: {v}",
  "EXP does not store thread colours – only colour changes.": "EXP lagrer ikke trådfarger – bare fargeskift.",
  "Earlier": "Tidligere",
  "Edge run": "Kantløp",
  "Edit": "Rediger",
  "Edit nodes": "Rediger noder",
  "Editable shapes": "Redigerbare former",
  "Ellipse (fill)": "Ellipse (fyll)",
  "Embedded images in the SVG were skipped.": "Innebygde bilder i SVG er hoppet over.",
  "Error": "Feil",
  "Estimate based on the machine settings": "Estimat basert på maskininnstillingene",
  "Exact RGB colours": "Eksakte RGB-farger",
  "Expected VP3 block 00 0{tag} 00 at byte {pos}.": "Forventet VP3-blokk 00 0{tag} 00 ved byte {pos}.",
  "Expected a CEmbOne block.": "Forventet CEmbOne-blokk.",
  "Expected a CSewSeg block.": "Forventet CSewSeg-blokk.",
  "Export": "Eksporter",
  "Export embroidery file": "Eksporter broderifil",
  "File format": "Filformat",
  "File size": "Filstørrelse",
  "Fill": "Fyll",
  "Fill angle": "Fyllvinkel",
  "Fill stitch needs a closed shape. Close the line or use running stitch.": "Fyllsting krever en lukket form. Lukk linjen eller bruk løpesting.",
  "Fill {n}": "Fyll {n}",
  "First": "Først",
  "Fit to window (F)": "Tilpass til vinduet (F)",
  "Follow the design": "Følg designet",
  "Fully embroidered (filled background)": "Helbrodert (fylt bakgrunn)",
  "Generated stitches": "Genererte sting",
  "Generating stitches…": "Genererer sting…",
  "Gradients are not supported; the first colour stop is used.": "Fargeoverganger (gradienter) støttes ikke; første fargestopp er brukt.",
  "Group objects by colour": "Grupper objekter etter farge",
  "Grows the shape so it overlaps neighbouring objects": "Utvider formen slik at den overlapper naboobjekter",
  "Has a warning": "Har advarsel",
  "Has errors": "Har feil",
  "Height": "Høyde",
  "Height (stitches)": "Høyde (sting)",
  "Hidden objects are not sewn and are not included in the export": "Skjulte objekter sys ikke og er ikke med i eksporten",
  "Hide (do not sew)": "Skjul (sys ikke)",
  "Hide – the object is not sewn and not included in the export": "Skjul – objektet sys ikke og tas ikke med i eksporten",
  "Hoop": "Ramme",
  "Hoop (sewing field)": "Ramme (arbeidsområde)",
  "Hoop and placement": "Ramme og plassering",
  "Hoop height": "Rammehøyde",
  "Hoop width": "Rammebredde",
  "Image": "Bilde",
  "Import an image (PNG, JPEG or SVG) for automatic digitizing, or draw shapes yourself with the tools on the left.": "Importer et bilde (PNG, JPEG eller SVG) for automatisk digitalisering, eller tegn former selv med verktøyene til venstre.",
  "Import an image for automatic digitizing, or draw shapes with the tools.": "Importer et bilde for automatisk digitalisering, eller tegn former med verktøyene.",
  "Import as vector shapes": "Importer som vektorformer",
  "Import image": "Importer bilde",
  "Import project file": "Importer prosjektfil",
  "Imported {n} vector shapes in {c} colours.": "Importerte {n} vektorformer i {c} farger.",
  "Imported “{name}”. Save it to keep it in the browser.": "Importerte «{name}». Lagre for å beholde det i nettleseren.",
  "Info": "Info",
  "Inset": "Innrykk",
  "Internal error in DST encoding": "Intern feil i DST-koding",
  "Invalid PEC offset in the PES file.": "Ugyldig PEC-offset i PES-filen.",
  "Invalid PEC stitch block signature.": "Ugyldig PEC-stingblokksignatur.",
  "Invalid VP3 stitch block.": "Ugyldig VP3-stingblokk.",
  "Invalid coordinates were generated. Check the shape.": "Ugyldige koordinater ble generert. Kontroller formen.",
  "Invalid image data.": "Ugyldige bildedata.",
  "Invalid long VP3 displacement.": "Ugyldig lang VP3-forskyvning.",
  "Invalid path data in SVG.": "Ugyldige stidata i SVG.",
  "Invalid position {pos}": "Ugyldig posisjon {pos}",
  "Invalid project: {msg}": "Ugyldig prosjekt: {msg}",
  "Invalid section separator in CSewSeg.": "Ugyldig seksjonsskille i CSewSeg.",
  "Invalid start of the PEC stitch block.": "Ugyldig start på PEC-stingblokk.",
  "Invalid stitch offset in the JEF header.": "Ugyldig stingoffset i JEF-header.",
  "JEF displacement outside ±127: {v}": "JEF-forskyvning utenfor ±127: {v}",
  "JEF export does not support stops without a colour change.": "JEF-eksporten støtter ikke stopp uten fargeskift.",
  "JEF has no trim command; the machine trims jumps according to its own setting.": "JEF har ingen klippkommando; maskinen klipper hopp etter egen innstilling.",
  "Janome, Elna and Kenmore": "Janome, Elna og Kenmore",
  "Jump records": "Hopp-poster",
  "Jump sequence (Tajima convention)": "Hoppsekvens (Tajima-konvensjon)",
  "Jumps": "Hopp",
  "Jumps and trims": "Hopp og klipp",
  "Keep aspect ratio": "Bevar sideforhold",
  "Language": "Språk",
  "Last": "Sist",
  "Later": "Senere",
  "Line": "Linje",
  "Line (running stitch)": "Linje (løpesting)",
  "Line {n}": "Linje {n}",
  "Loading …": "Laster …",
  "Lock": "Lås",
  "Lock against editing": "Lås mot redigering",
  "Lock aspect ratio": "Lås sideforhold",
  "Lock object": "Lås objektet",
  "Machine": "Maskin",
  "Make a patch (badge) around the design": "Lag patch (merke) rundt designet",
  "Make patch": "Lag patch",
  "Manual: use as background": "Manuell: bruk som bakgrunn",
  "Max stitch length": "Maks stinglengde",
  "Max width before split": "Maks bredde før splitting",
  "Melco/Bernina and compatibles": "Melco/Bernina og kompatible",
  "Merge": "Slå sammen",
  "Merge with another colour": "Slå sammen med en annen farge",
  "Merge with {colour}": "Slå sammen med {colour}",
  "Method": "Metode",
  "Minimum stitch length": "Minste stinglengde",
  "Minimum stitch length cannot be larger than the stitch length.": "Minste stinglengde kan ikke være større enn stinglengden.",
  "Missing migration from version {v}.": "Mangler migrering fra versjon {v}.",
  "Mixed": "Blandet",
  "More…": "Mer…",
  "Move all objects to:": "Flytt alle objekter til:",
  "Move colour up": "Flytt farge opp",
  "Move end point": "Flytt sluttpunkt",
  "Move start point": "Flytt startpunkt",
  "Move up": "Flytt opp",
  "Nearest colour in the machine palette": "Nærmeste farge i maskinpalett",
  "New colour": "Ny farge",
  "New project": "Nytt prosjekt",
  "No colours (colour changes only)": "Ingen farger (kun fargeskift)",
  "No objects selected": "Ingen objekter valgt",
  "No objects yet": "Ingen objekter ennå",
  "No preview": "Ingen forhåndsvisning",
  "No saved projects": "Ingen lagrede prosjekter",
  "No shapes found in the SVG file. Text must be converted to outlines before importing.": "Fant ingen former i SVG-filen. Tekst må konverteres til konturer før import.",
  "No stitches to show. Add objects first.": "Ingen sting å vise. Legg til objekter først.",
  "No stitches yet": "Ingen sting ennå",
  "Not a PEC file.": "Ikke en PEC-fil.",
  "Not a PES file (missing the #PES signature).": "Ikke en PES-fil (mangler #PES-signatur).",
  "Not a VP3 file (missing %vsm%).": "Ikke en VP3-fil (mangler %vsm%).",
  "Number of colours": "Antall farger",
  "Object": "Objekt",
  "Object list": "Objektliste",
  "Object name": "Objektnavn",
  "Object {n}": "Objekt {n}",
  "Objects": "Objekter",
  "Objects are sewn in list order. Grouping by colour (in palette order) gives the fewest colour changes, but may change which objects end up on top.": "Objekter sys i listerekkefølgen. Gruppering etter farge (i palettrekkefølge) gir færrest mulig fargeskift, men kan endre hvilke objekter som ligger øverst.",
  "Objects in sewing order": "Objekter i syrekkefølge",
  "Objects · sewing order": "Objekter · syrekkefølge",
  "One stitch back": "Ett sting tilbake",
  "One stitch forward": "Ett sting frem",
  "Open {name}": "Åpne {name}",
  "Order": "Rekkefølge",
  "Original image": "Originalbildet",
  "Original · drag to crop": "Original · dra for å beskjære",
  "Oval": "Oval",
  "Overlap": "Overlapp",
  "Own trim command": "Egen klippkommando",
  "PEC displacement outside ±2047: {v}": "PEC-forskyvning utenfor ±2047: {v}",
  "PEC/PES does not support stop commands without a colour change.": "PEC/PES støtter ikke stoppkommandoer uten fargeskift.",
  "PES does not support stop commands without a colour change.": "PES støtter ikke stoppkommandoer uten fargeskift.",
  "PES supports at most 255 colour blocks.": "PES støtter maks 255 fargeblokker.",
  "PES v6 stores the exact thread colours and names in the file. The machine sews from the PEC part, which shows the nearest Brother colour.": "PES v6 lagrer de eksakte trådfargene og navnene i filen. Maskinen syr fra PEC-delen, som viser nærmeste Brother-farge.",
  "PNG, JPEG or SVG, max 25 MB. The image is processed only in your browser and is never uploaded. Transparency in PNG and SVG is used as background.": "PNG, JPEG eller SVG, maks 25 MB. Bildet behandles bare i nettleseren din og lastes ikke opp noe sted. Gjennomsiktighet i PNG og SVG brukes som bakgrunn.",
  "Pan": "Panorer",
  "Parts of the design are outside the hoop with the chosen placement. Centre the design in the hoop.": "Deler av designet ligger utenfor rammen med valgt plassering. Sentrer designet i rammen.",
  "Passes": "Passeringer",
  "Passes must be a whole number.": "Passeringer må være et heltall.",
  "Patch": "Patch",
  "Patch added. The machine stops after the placement line (lay the fabric) and after the tack-down (trim away the excess).": "Patch lagt til. Maskinen stopper etter plasseringslinjen (legg på stoffet) og etter festesømmen (klipp bort overskuddet).",
  "Patch added: background, design and satin border.": "Patch lagt til: bakgrunn, design og satengkant.",
  "Patch preview": "Forhåndsvisning av patch",
  "Patch shape": "Patchform",
  "Patch – background": "Patch – bakgrunn",
  "Patch – border": "Patch – kant",
  "Patch – placement (stop)": "Patch – plassering (stopp)",
  "Patch – placement line": "Patch – plasseringslinje",
  "Patch – satin border": "Patch – satengkant",
  "Patch – tack-down": "Patch – festesøm",
  "Patch – tack-down (stop)": "Patch – festesøm (stopp)",
  "Pause": "Pause",
  "Pfaff and Husqvarna Viking": "Pfaff og Husqvarna Viking",
  "Placement line → stop (lay the fabric) → tack-down → stop (trim away the fabric outside) → design → satin border.": "Plasseringslinje → stopp (legg på stoffet) → festesøm → stopp (klipp bort stoffet utenfor) → design → satengkant.",
  "Play": "Spill av",
  "Polygon (fill)": "Polygon (fyll)",
  "Position": "Posisjon",
  "Position and size": "Plassering og størrelse",
  "Preview of the colour separation": "Forhåndsvisning av fargeseparering",
  "Project name": "Prosjektnavn",
  "Project not found.": "Fant ikke prosjektet.",
  "Project not found. It may have been deleted.": "Fant ikke prosjektet. Det kan være slettet.",
  "Projects": "Prosjekter",
  "Projects are stored only in this browser (IndexedDB). Download the project file as a backup or to move the project to another computer.": "Prosjektene lagres bare i denne nettleseren (IndexedDB). Last ned prosjektfilen for sikkerhetskopi eller for å flytte prosjektet til en annen maskin.",
  "Projects on this device": "Prosjekter på denne enheten",
  "Properties": "Egenskaper",
  "Pull compensation": "Trekkompensasjon",
  "Reading the image…": "Leser bildet…",
  "Ready for export": "Klar for eksport",
  "Rectangle": "Rektangel",
  "Rectangle (fill)": "Rektangel (fyll)",
  "Redo": "Gjør om",
  "Remaining ≈ {time} (estimate)": "Gjenstår ≈ {time} (estimat)",
  "Remove patch": "Fjern patch",
  "Remove solid background": "Fjern ensfarget bakgrunn",
  "Remove unused": "Fjern ubrukte",
  "Removed: {colour}": "Fjernet: {colour}",
  "Rename": "Gi nytt navn",
  "Replace the existing design": "Erstatt eksisterende design",
  "Reset crop": "Nullstill utsnitt",
  "Rotate (Shift = 15° steps)": "Roter (Shift = 15°-trinn)",
  "Rotation": "Rotasjon",
  "Rounded rectangle": "Avrundet rektangel",
  "Row spacing": "Radavstand",
  "Row spacing (density)": "Radavstand (tetthet)",
  "Run": "Løp",
  "Running stitch": "Løpesting",
  "Running stitch and satin run towards the end point. Fill starts and ends at the nearest possible row ends (where the rows are shortest).": "Løpesting og sateng går mot sluttpunktet. Fyll starter og slutter ved de nærmeste mulige radendene (der radene er kortest).",
  "SVG – vector import": "SVG – vektorimport",
  "Satin": "Sateng",
  "Satin column": "Satengkolonne",
  "Satin line": "Satenglinje",
  "Satin needs a shape without holes. Use fill stitch, or draw a satin column.": "Sateng krever en form uten hull. Bruk fyllsting, eller tegn en satengkolonne.",
  "Satin up to": "Sateng opptil",
  "Satin {n}": "Sateng {n}",
  "Save": "Lagre",
  "Save current project": "Lagre gjeldende prosjekt",
  "Save locally": "Lagre lokalt",
  "Save what you are working on and it will show up here.": "Lagre det du jobber med, så dukker det opp her.",
  "Scale (Shift = keep proportions)": "Skaler (Shift = behold proporsjoner)",
  "Scaling changes the shapes; the stitch density is kept, so the stitch count changes.": "Skalering endrer formene; stingtetthet beholdes, så stingantallet endres.",
  "Select": "Velg",
  "Select an object on the canvas or in the object list to change its shape, colour and stitches. Draw new shapes with the tools on the left.": "Velg et objekt i lerretet eller i objektlisten for å endre form, farge og sting. Tegn nye former med verktøyene til venstre.",
  "Select and move": "Velg og flytt",
  "Select objects with this colour": "Velg objekter med denne fargen",
  "Separate again": "Skill ut igjen",
  "Settings": "Innstillinger",
  "Sew connections shorter than": "Sy forbindelser kortere enn",
  "Sew earlier": "Sy tidligere",
  "Sew later": "Sy senere",
  "Sew simulation": "Sy-simulering",
  "Sew this colour": "Sy denne fargen",
  "Sewing time": "Sy-tid",
  "Sewing time (estimate)": "Sy-tid (estimat)",
  "Shape": "Form",
  "Shapes": "Former",
  "Shield": "Skjold",
  "Short stitches in tight curves": "Korte sting i krappe kurver",
  "Show": "Vis",
  "Show (sew)": "Vis (sys)",
  "Show at actual size": "Vis i faktisk størrelse",
  "Show jumps and trims": "Vis hopp og klipp",
  "Show – the object is sewn and exported again": "Vis – objektet sys og eksporteres igjen",
  "Size": "Størrelse",
  "Smallest detail": "Minste detalj",
  "Smoothing": "Glatting",
  "Speed": "Hastighet",
  "Split wide stitches": "Del opp brede sting",
  "Stagger (rows)": "Forskyvning (rader)",
  "Start a new embroidery design": "Start et nytt broderidesign",
  "Start, end and tie-off": "Start, slutt og festesting",
  "Statistics": "Statistikk",
  "Stitch angle": "Stingretning",
  "Stitch choices": "Stingvalg",
  "Stitch error: {error}": "Stingfeil: {error}",
  "Stitch generation failed: {error}. Simplify the shape or change the stitch type.": "Stinggenerering feilet: {error}. Forenkle formen eller bytt stingtype.",
  "Stitch length": "Stinglengde",
  "Stitch position": "Stingposisjon",
  "Stitch simulation": "Stingsimulering",
  "Stitch type": "Stingtype",
  "Stitch type for all": "Stingtype for alle",
  "Stitches": "Sting",
  "Tajima and most industrial machines": "Tajima og de fleste industrimaskiner",
  "Tatami underlay (90°)": "Tatami-underlag (90°)",
  "Text in SVG is not supported. Convert the text to outlines (Object → Object to Path) before importing.": "Tekst i SVG støttes ikke. Konverter teksten til konturer (Objekt → Konverter til baner) før import.",
  "The DST file is missing the end command (0xF3).": "DST-filen mangler sluttkommando (0xF3).",
  "The DST file is shorter than its header (512 bytes).": "DST-filen er kortere enn headeren (512 byte).",
  "The DST header is missing the LA field.": "DST-header mangler LA-feltet.",
  "The EXP file has an odd number of bytes.": "EXP-filen har et odde antall byte.",
  "The JEF file is missing the end code (0x80 0x10).": "JEF-filen mangler sluttkode (0x80 0x10).",
  "The PEC section is missing \"LA:\".": "PEC-seksjonen mangler \"LA:\".",
  "The PEC stitch block is missing the end code (0xFF).": "PEC-stingblokken mangler sluttkode (0xFF).",
  "The SVG drawing has no size.": "SVG-tegningen har ingen utstrekning.",
  "The SVG file could not be drawn. External resources and scripts are not supported.": "SVG-filen kunne ikke tegnes. Eksterne ressurser og skript støttes ikke.",
  "The SVG file could not be read.": "SVG-filen kunne ikke leses.",
  "The SVG file could not be read. Check that it is valid.": "SVG-filen kunne ikke leses. Kontroller at den er gyldig.",
  "The SVG shapes have neither fill nor stroke.": "SVG-formene har verken fyll eller strek.",
  "The VP3 design block is corrupt.": "VP3-designblokken er ødelagt.",
  "The VP3 design block is missing xxPP.": "VP3-designblokk mangler xxPP.",
  "The VP3 file block is longer than the file.": "VP3-filblokken er lengre enn filen.",
  "The background is filled with stitches. Sew on stabilizer and cut out along the edge.": "Bakgrunnen fylles med sting. Sy på stabilisering og klipp ut langs kanten.",
  "The browser cannot draw the image (Canvas is missing).": "Nettleseren kan ikke tegne bildet (Canvas mangler).",
  "The design ({w} × {h} mm) is larger than the hoop {hoop}. Scale the design down or choose a larger hoop.": "Designet ({w} × {h} mm) er større enn rammen {hoop}. Skaler ned designet eller velg en større ramme.",
  "The design has a very large number of stitches ({n}). Many machines limit the stitch count; consider a lower density.": "Designet har svært mange sting ({n}). Mange maskiner har grenser for stingantall; vurder lavere tetthet.",
  "The design has errors that must be fixed before export:": "Designet har feil som må rettes før eksport:",
  "The design has no stitches to export. Add objects or digitize an image.": "Designet har ingen sting å eksportere. Legg til objekter eller digitaliser et bilde.",
  "The design has {n} stitches (max {max}). Make the design smaller or increase the row spacing.": "Designet har {n} sting (maks {max}). Gjør designet mindre eller øk radavstanden.",
  "The design is empty. The patch is created anyway, but import or draw the motif first to fit the size.": "Designet er tomt. Patchen lages likevel, men importer eller tegn motivet først for å tilpasse størrelsen.",
  "The design is too large for {format}.": "Designet er for stort for {format}.",
  "The design is too large for {format}: coordinate ({x} mm, {y} mm) exceeds the format limit of ±{max} mm.": "Designet er for stort for {format}: koordinat ({x} mm, {y} mm) overskrider formatets grense på ±{max} mm.",
  "The design width must be greater than 0 mm.": "Designbredden må være større enn 0 mm.",
  "The file is empty.": "Filen er tom.",
  "The file is not a StitchCraft project.": "Filen er ikke et StitchCraft-prosjekt.",
  "The file is {size} MB. The maximum size is {max} MB – save the image at a lower resolution.": "Filen er {size} MB. Maks størrelse er {max} MB – lagre bildet i lavere oppløsning.",
  "The hoop must have a positive width and height.": "Rammen må ha positiv bredde og høyde.",
  "The image could not be decoded. The file may be damaged.": "Bildet kunne ikke dekodes. Filen kan være skadet.",
  "The image could not be read: {error}": "Bildet kunne ikke leses: {error}",
  "The image has no visible content after transparency and background were removed. Turn off background removal or choose another image.": "Bildet har ikke noe synlig innhold etter at gjennomsiktighet og bakgrunn er fjernet. Slå av bakgrunnsfjerning eller velg et annet bilde.",
  "The image is empty.": "Bildet er tomt.",
  "The image is too large ({w} × {h} pixels). The maximum is {max} megapixels.": "Bildet er for stort ({w} × {h} piksler). Maks er {max} megapiksler.",
  "The image is {w} × {h} pixels. The maximum is {max} megapixels.": "Bildet er {w} × {h} piksler. Maks er {max} megapiksler.",
  "The image was added as a background. Draw shapes on top with the tools (polygon, line, rectangle …).": "Bildet er lagt inn som bakgrunn. Tegn former oppå med verktøyene (polygon, linje, rektangel …).",
  "The line needs at least two points.": "Linjen må ha minst to punkter.",
  "The object produced no stitches. The shape may be too small for the selected stitch type.": "Objektet ga ingen sting. Formen kan være for liten for valgt stingtype.",
  "The order below is the sewing order of the colours. Change a colour to move the borders between the colour areas.": "Rekkefølgen under er syrekkefølgen for fargene. Endre en farge for å flytte grensene mellom fargeområdene.",
  "The original image in the project could not be read. The design was opened without an image.": "Originalbildet i prosjektet kunne ikke leses. Designet er åpnet uten bilde.",
  "The outer edge of the satin border is the edge of the patch. Actual size: {w} × {h} mm.": "Ytterkanten av satengkanten er patchens kant. Faktisk størrelse: {w} × {h} mm.",
  "The outline crosses itself. It is interpreted with the even-odd rule; fix the nodes for a predictable result.": "Konturen krysser seg selv. Den er tolket med partall/oddetall-regelen; rett opp nodene for et forutsigbart resultat.",
  "The palette is empty. Digitize an image or add a colour.": "Paletten er tom. Digitaliser et bilde eller legg til en farge.",
  "The project file has no valid version number.": "Prosjektfilen mangler gyldig versjonsnummer.",
  "The project file is not valid JSON.": "Prosjektfilen er ikke gyldig JSON.",
  "The project file is too large.": "Prosjektfilen er for stor.",
  "The project was made with a newer version (format {v}). Update StitchCraft to open it.": "Prosjektet er laget med en nyere versjon (format {v}). Oppdater StitchCraft for å åpne det.",
  "The satin column is too short to produce stitches.": "Satengkolonnen er for kort til å gi sting.",
  "The satin column needs two rails with at least two points each.": "Satengkolonnen trenger to skinner med minst to punkter hver.",
  "The satin is up to {width} mm wide (max {max} mm). Enable splitting, make the shape narrower or use fill stitch.": "Satengen er opptil {width} mm bred (maks {max} mm). Slå på splitting, gjør formen smalere eller bruk fyllsting.",
  "The sewing time is a rough estimate based on the speed, colour changes and trims above. The actual time depends on the machine.": "Sy-tiden er et grovt estimat basert på hastighet, fargeskift og klipp over. Faktisk tid avhenger av maskinen.",
  "The shape has no area. Delete the object or draw the shape again.": "Formen har ikke noe areal. Slett objektet eller tegn formen på nytt.",
  "The shape is too narrow for fill stitch at this row spacing. Use satin or running stitch.": "Formen er for smal for fyllsting med valgt radavstand. Bruk sateng eller løpesting.",
  "The shape is too narrow for underlay; underlay was left out.": "Formen er for smal for underlag; underlag er utelatt.",
  "The shape must have at least {n} points.": "Formen må ha minst {n} punkter.",
  "The shapes in the SVG file are imported directly as editable curves: filled shapes become fill, and strokes become running stitch or satin. This gives the most precise edges. The colour settings below apply only to pixel-based digitizing.": "Formene i SVG-filen importeres direkte som redigerbare kurver: fylte former blir fyll, og streker blir løpesting eller sateng. Det gir mest presise kanter. Fargeinnstillingene under gjelder bare pikselbasert digitalisering.",
  "This browser does not support local storage (IndexedDB).": "Nettleseren støtter ikke lokal lagring (IndexedDB).",
  "This file type is not supported. Use PNG, JPEG or SVG.": "Filtypen støttes ikke. Bruk PNG, JPEG eller SVG.",
  "Thread (top thread)": "Tråd (overtråd)",
  "Thread colour": "Trådfarge",
  "Thread palette": "Trådpalett",
  "Tie-in at start": "Festesting ved start",
  "Tie-off before trims": "Festesting før klipp",
  "Time per colour change": "Tid per fargeskift",
  "Time per trim": "Tid per klipp",
  "Timeline": "Tidslinje",
  "To end": "Til slutt",
  "To start": "Til start",
  "Too many colour changes for PEC (max 255).": "For mange fargeskift for PEC (maks 255).",
  "Tools": "Verktøy",
  "Tracing outlines": "Sporer konturer",
  "Trim jumps longer than": "Klipp ved hopp lengre enn",
  "Trims": "Klipp",
  "Trims are written as three jumps with no net movement (Tajima convention).": "Klipp skrives som tre hopp uten nettobevegelse (Tajima-konvensjon).",
  "Truncated EXP control record.": "Avkortet EXP-kontrollpost.",
  "Underlay": "Underlag",
  "Undo": "Angre",
  "Unexpected PEC icon format.": "Uventet PEC-ikonformat.",
  "Unexpected PES v6 header.": "Uventet PES v6-header.",
  "Unexpected end of file at byte {pos}": "Uventet slutt på filen ved byte {pos}",
  "Unknown": "Ukjent",
  "Unknown EXP control code 0x{code}.": "Ukjent EXP-kontrollkode 0x{code}.",
  "Unknown JEF control code 0x{code}.": "Ukjent JEF-kontrollkode 0x{code}.",
  "Unknown SVG path command “{cmd}”.": "Ukjent SVG-stikommando «{cmd}».",
  "Unknown VP3 control code 0x{code}.": "Ukjent VP3-kontrollkode 0x{code}.",
  "Unlock": "Lås opp",
  "Unsaved changes": "Ulagrede endringer",
  "Untitled": "Uten navn",
  "Update patch": "Oppdater patch",
  "Updating stitches…": "Oppdaterer sting…",
  "Updating the stitches …": "Stingene oppdateres …",
  "Use PES v1 if an older machine or program cannot open the file.": "Bruk PES v1 hvis en eldre maskin eller programvare ikke åpner filen.",
  "Use satin on narrow areas": "Bruk sateng på smale områder",
  "VP3 export does not support stops without a colour change.": "VP3-eksporten støtter ikke stopp uten fargeskift.",
  "VP3 has no jump command; moves are stored as long displacements (normally right after a trim).": "VP3 har ingen hoppkommando; forflytninger lagres som lange forskyvninger (normalt rett etter klipp).",
  "VP3 with {n} designs is not supported.": "VP3 med {n} design støttes ikke.",
  "Validate and download .{ext}": "Valider og last ned .{ext}",
  "Validation of {format} failed: {details}.": "Validering av {format} feilet: {details}.",
  "Verification read of {format} failed: {error}": "Kontrollesing av {format} feilet: {error}",
  "Very wide strokes are sewn as 12 mm satin. Convert them to filled shapes for a better result.": "Svært brede streker er sydd som 12 mm sateng. Konverter dem til fylte former for bedre resultat.",
  "View": "Visning",
  "Warning": "Advarsel",
  "Wide sections (up to {width} mm) are split into several stitches.": "Brede partier (opptil {width} mm) er delt opp i flere sting.",
  "Width": "Bredde",
  "Width (line)": "Bredde (linje)",
  "Width (stitches)": "Bredde (sting)",
  "Your work has been restored from your last session.": "Arbeidet ditt er gjenopprettet fra forrige økt.",
  "Zigzag spacing (same side)": "Sikksakk-avstand (samme side)",
  "Zigzag underlay": "Sikksakk-underlag",
  "Zoom": "Zoom",
  "Zoom in (+)": "Zoom inn (+)",
  "Zoom out (−)": "Zoom ut (−)",
  "colour change": "fargeskift",
  "colour changes differ ({e} vs {a})": "fargeskift avviker ({e} vs {a})",
  "colour {i} is invalid": "farge {i} er ugyldig",
  "crop": "utsnitt",
  "design is missing": "design mangler",
  "design is missing objects or palette": "design mangler objekter eller palett",
  "end": "slutt",
  "estimate": "estimat",
  "fill": "fyll",
  "height": "høyde",
  "id is missing": "id mangler",
  "image data is invalid": "bildedata er ugyldige",
  "invalid": "ugyldig",
  "jump": "hopp",
  "locked": "låst",
  "missing": "mangler",
  "move {i}: expected ({ex}, {ey}{ej}), found ({ax}, {ay}{aj})": "bevegelse {i}: forventet ({ex}, {ey}{ej}), fant ({ax}, {ay}{aj})",
  "not sewn": "sys ikke",
  "number of moves: expected {e}, found {a}": "antall bevegelser: forventet {e}, fant {a}",
  "object {i} has an invalid shape": "objekt {i} har ugyldig form",
  "object {i} has no id/colour": "objekt {i} mangler id/farge",
  "object {i} has no transform": "objekt {i} mangler transform",
  "object {i} is invalid": "objekt {i} er ugyldig",
  "open": "åpen",
  "rotation": "rotasjon",
  "running stitch": "løpesting",
  "satin": "sateng",
  "scale": "skala",
  "stitch": "sting",
  "stitch parameters are missing": "stingparametere mangler",
  "stop": "stopp",
  "trim": "klipp",
  "trims differ ({e} vs {a})": "klipp avviker ({e} vs {a})",
  "unknown image type {mime}": "ukjent bildetype {mime}",
  "unknown stitch type {type}": "ukjent stingtype {type}",
  "was written, read back and checked against the internal stitch sequence.": "er skrevet, lest tilbake og kontrollert mot den interne stingsekvensen.",
  "width": "bredde",
  "{h} h {m} min": "{h} t {m} min",
  "{kind} · no. {n} of {total} in the sewing order · {stitches} stitches": "{kind} · nr. {n} av {total} i syrekkefølgen · {stitches} sting",
  "{label} must be between {min} and {max}{unit} (is {value}).": "{label} må være mellom {min} og {max}{unit} (er {value}).",
  "{m} min {s} s": "{m} min {s} s",
  "{name} (copy)": "{name} (kopi)",
  "{name} · {type} · {n} stitches": "{name} · {type} · {n} sting",
  "{n} cmd/s": "{n} kmd/s",
  "{n} error(s)": "{n} feil",
  "{n} hidden object ({names}) is not in the file. Show it in the object list if it should be sewn.": "{n} skjult objekt ({names}) er ikke med i filen. Vis det i objektlisten hvis det skal sys.",
  "{n} hidden objects ({names}) are not in the file. Show them in the object list if they should be sewn.": "{n} skjulte objekter ({names}) er ikke med i filen. Vis dem i objektlisten hvis de skal sys.",
  "{n} hidden – not sewn": "{n} skjult – sys ikke",
  "{n} objects": "{n} objekter",
  "{n} objects selected": "{n} objekter valgt",
  "{n} points · Enter/double-click finishes · Backspace removes a point · Esc cancels": "{n} punkt · Enter/dobbeltklikk fullfører · Backspace angrer punkt · Esc avbryter",
  "{n} problem(s) in the design must be fixed before export.": "Designet har {n} feil som må rettes før eksport.",
  "{n} small areas were merged.": "{n} små områder ble slått sammen.",
  "{n} warning(s)": "{n} advarsler",
  "{s} s": "{s} s",
  "{what} must be a number": "{what} må være et tall",
  "“{name}” is saved locally in the browser.": "«{name}» er lagret lokalt i nettleseren.",
  "“{name}” uses a colour that is not in the palette. Choose a new colour.": "«{name}» bruker en farge som ikke finnes i paletten. Velg en ny farge.",
  "New": "Ny",
  "Start a new project?": "Starte et nytt prosjekt?",
  "“{name}” has unsaved changes. Do you want to save them before you start a new project?": "«{name}» har endringer som ikke er lagret. Vil du lagre dem før du starter et nytt prosjekt?",
  "Discard changes": "Forkast endringene",
  "Save and start new": "Lagre og start nytt",
  "Enter saves · Esc cancels": "Enter lagrer · Esc avbryter",
  "Measure": "Mål",
  "Length {len} mm ({inch} in) · Δx {dx} mm · Δy {dy} mm · angle {angle}°": "Lengde {len} mm ({inch} tommer) · Δx {dx} mm · Δy {dy} mm · vinkel {angle}°",
  "Click two points to measure · Shift = 15° steps · snaps to nodes · Esc clears": "Klikk på to punkter for å måle · Shift = 15°-trinn · fester seg til noder · Esc fjerner",
  "Embroidery machine": "Broderimaskin",
  "Generic (all hoop sizes)": "Generell (alle rammestørrelser)",
  "Only the hoops this machine accepts are shown. Check the sizes against the manual for your machine.": "Bare rammene denne maskinen kan bruke vises. Kontroller størrelsene mot håndboken for maskinen din.",
  "File name": "Filnavn",
  "Change the name in the top bar.": "Endre navnet i topplinjen.",
  "Import an image (PNG, JPEG or SVG) for automatic digitizing, or draw shapes yourself with the tools below.": "Importer et bilde (PNG, JPEG eller SVG) for automatisk digitalisering, eller tegn former selv med verktøyene nedenfor.",
  "Menu": "Meny",
  "Import": "Importer",
  "More": "Mer",
  "Simulate": "Simuler",
  "Delete node": "Slett node",
  "Copy": "Kopier",
  "Cut": "Klipp ut",
  "Paste": "Lim inn",
  "A new code is on its way to {email}. You can ask for a new code once a minute.": "En ny kode er på vei til {email}. Du kan be om en ny kode én gang i minuttet.",
  "A test email is sent to {email}.": "En testmelding er sendt til {email}.",
  "Account": "Konto",
  "Account: {email}": "Konto: {email}",
  "Accounts are not available on this server.": "Kontoer er ikke tilgjengelige på denne serveren.",
  "Active": "Aktiv",
  "Administration": "Administrasjon",
  "Administrator": "Administrator",
  "Back to log in": "Tilbake til innlogging",
  "Block": "Sperr",
  "Blocked": "Sperret",
  "Brevo API key": "API-nøkkel for Brevo",
  "Change password": "Bytt passord",
  "Choose a new password": "Velg nytt passord",
  "Code from the email": "Kode fra e-posten",
  "Confirm": "Bekreft",
  "Confirm your email address": "Bekreft e-postadressen",
  "Confirm your email address first. Enter the code we sent you.": "Bekreft e-postadressen først. Skriv inn koden vi sendte deg.",
  "Create account": "Opprett konto",
  "Create an account": "Opprett konto",
  "Created {date}": "Opprettet {date}",
  "Current password": "Nåværende passord",
  "Delete user": "Slett bruker",
  "Delete {email} and their cloud projects": "Slett {email} og skyprosjektene",
  "Email": "E-post",
  "Emails (codes for confirming addresses and resetting passwords) are sent with Brevo.": "E-post (koder for å bekrefte adresser og nullstille passord) sendes med Brevo.",
  "Enter a valid email address.": "Skriv inn en gyldig e-postadresse.",
  "Forgot password": "Glemt passord",
  "Forgot password?": "Glemt passordet?",
  "If {email} has an account, we have sent a code to it.": "Hvis {email} har en konto, har vi sendt en kode dit.",
  "In the cloud": "I skyen",
  "In this browser": "I denne nettleseren",
  "Log in": "Logg inn",
  "Log out": "Logg ut",
  "Logged in as {email}.": "Logget inn som {email}.",
  "Make admin": "Gjør til administrator",
  "Member since": "Medlem siden",
  "New password": "Nytt passord",
  "New password (at least {n} characters)": "Nytt passord (minst {n} tegn)",
  "No API key: emails cannot be sent.": "Ingen API-nøkkel: e-post kan ikke sendes.",
  "No connection to the server.": "Ingen forbindelse med serveren.",
  "Not confirmed": "Ikke bekreftet",
  "Not found.": "Finnes ikke.",
  "Password": "Passord",
  "Password (at least {n} characters)": "Passord (minst {n} tegn)",
  "Remove admin role": "Fjern administratorrollen",
  "Remove the stored key": "Fjern den lagrede nøkkelen",
  "Role": "Rolle",
  "Save new password": "Lagre nytt passord",
  "Search by email": "Søk etter e-post",
  "Send a new code": "Send ny kode",
  "Send a test email to {email}": "Send testmelding til {email}",
  "Send code": "Send kode",
  "Sender address": "Avsenderadresse",
  "Sender name": "Avsendernavn",
  "Show more": "Vis flere",
  "Something went wrong on the server. Try again.": "Noe gikk galt på serveren. Prøv igjen.",
  "Stored ({hint}) – leave empty to keep it": "Lagret ({hint}) – la feltet stå tomt for å beholde den",
  "Superadmin": "Superadmin",
  "The API key comes from the server environment (BREVO_API_KEY).": "API-nøkkelen kommer fra servermiljøet (BREVO_API_KEY).",
  "The API key is stored here (encrypted).": "API-nøkkelen er lagret her (kryptert).",
  "The code has expired. Ask for a new code.": "Koden har gått ut. Be om en ny kode.",
  "The code is not correct.": "Koden er ikke riktig.",
  "The email could not be sent. Try again later or contact the administrator.": "E-posten kunne ikke sendes. Prøv igjen senere, eller kontakt administratoren.",
  "The email could not be sent: {detail}": "E-posten kunne ikke sendes: {detail}",
  "The email settings are saved.": "E-postinnstillingene er lagret.",
  "The password is changed. Other devices are logged out.": "Passordet er byttet. Andre enheter er logget ut.",
  "The password must be at least {n} characters.": "Passordet må ha minst {n} tegn.",
  "The project could not be stored.": "Prosjektet kunne ikke lagres.",
  "The project is too large to store in the cloud.": "Prosjektet er for stort til å lagres i skyen.",
  "The sender address must be a verified sender or domain in Brevo.": "Avsenderadressen må være en bekreftet avsender eller et bekreftet domene i Brevo.",
  "This account is blocked. Contact the administrator.": "Kontoen er sperret. Kontakt administratoren.",
  "Too many attempts. Wait a little and try again.": "For mange forsøk. Vent litt og prøv igjen.",
  "Too many wrong attempts. Ask for a new code.": "For mange feil forsøk. Be om en ny kode.",
  "Unblock": "Opphev sperring",
  "User": "Bruker",
  "Users": "Brukere",
  "We have sent a code to {email}. If the address already has an account, log in instead.": "Vi har sendt en kode til {email}. Hvis adressen allerede har en konto, logger du inn i stedet.",
  "With an account you can store projects in the cloud and open them on other devices. Without one, StitchCraft works as before, in this browser only.": "Med en konto kan du lagre prosjekter i skyen og åpne dem på andre enheter. Uten konto virker StitchCraft som før, bare i denne nettleseren.",
  "Wrong email or password.": "Feil e-post eller passord.",
  "You are logged out. Projects in this browser are still here.": "Du er logget ut. Prosjektene i denne nettleseren ligger fortsatt her.",
  "You are not logged in.": "Du er ikke logget inn.",
  "You do not have access to this.": "Du har ikke tilgang til dette.",
  "You have reached the maximum number of cloud projects. Delete some first.": "Du har nådd maksimalt antall skyprosjekter. Slett noen først.",
  "Your email address is not confirmed yet. We have sent a new code to {email}.": "E-postadressen er ikke bekreftet ennå. Vi har sendt en ny kode til {email}.",
  "last logged in {date}": "sist innlogget {date}",
  "never logged in": "aldri logget inn",
  "{n} cloud projects": "{n} skyprosjekter",
  "{n} users": "{n} brukere",
  "“{name}” is saved in the browser and in the cloud.": "«{name}» er lagret i nettleseren og i skyen.",
  "“{name}” is saved in the browser, but not in the cloud: {error}": "«{name}» er lagret i nettleseren, men ikke i skyen: {error}",
  "“{name}” is saved in the cloud.": "«{name}» er lagret i skyen.",
  "1 user": "1 bruker",
  "Hide this tip": "Skjul tipset",
  "While you are logged in, everything you save is stored in the cloud and can be opened on all your devices.": "Når du er logget inn, lagres alt du lagrer i skyen, og du kan åpne det på alle enhetene dine.",
  "You are logged in as {email}: projects are saved in the cloud, with a copy in this browser.": "Du er logget inn som {email}: prosjektene lagres i skyen, med en kopi i denne nettleseren.",
  "Projects are saved in this browser.": "Prosjektene lagres i denne nettleseren.",
  "Log in to save them in the cloud.": "Logg inn for å lagre dem i skyen.",
  "{n} projects are only in this browser.": "{n} prosjekter ligger bare i denne nettleseren.",
  "Upload them to the cloud": "Last dem opp til skyen",
  "The folder is empty": "Mappen er tom",
  "Move projects here with “Move to folder”, or save the current project while the folder is open.": "Flytt prosjekter hit med «Flytt til mappe», eller lagre gjeldende prosjekt mens mappen er åpen.",
  "Folders": "Mapper",
  "All projects": "Alle prosjekter",
  "No folder": "Uten mappe",
  "New folder": "Ny mappe",
  "Folder name": "Mappenavn",
  "Create": "Opprett",
  "Rename folder": "Gi mappen nytt navn",
  "Delete the folder (the projects are kept)": "Slett mappen (prosjektene beholdes)",
  "Delete folder": "Slett mappe",
  "Move to folder": "Flytt til mappe",
  "Delete everywhere": "Slett overalt",
  "Only from this browser": "Bare fra denne nettleseren",
  "Only from the cloud": "Bare fra skyen",
  "Upload to the cloud": "Last opp til skyen",
  "More actions for {name}": "Flere valg for {name}",
  "Make a copy": "Lag en kopi",
  "Delete “{name}”": "Slett «{name}»",
};
